export default __webpack_public_path__ + "static/media/zone-filled.80e4589d.svg";